export default "__VITE_ASSET__BgnAlTlE__"